import { useState, useEffect, useRef } from "react";
import { Image } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function GenerateCustomizePublish() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className={`transition-all duration-700 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    backgroundColor: "#FFFFFF",
    fontFamily: '"Evergrow Sans", Inter, sans-serif',
    color: "rgb(20, 21, 31)"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');`}</style>

      <div className="page-container">
        <div className="py-10 md:py-20">
          <div className="flex flex-row gap-1 mb-16" style={{
          flexDirection: "row",
          gap: "4px",
          marginBottom: "64px"
        }}>
            <button style={{
            backgroundColor: "#F5F5F5",
            color: "rgb(20, 21, 31)",
            border: "1px solid #E0E0E0",
            borderRadius: "20px",
            padding: "8px 18px",
            fontSize: "13px",
            fontWeight: 400,
            fontFamily: '"Evergrow Sans", Inter, sans-serif',
            cursor: "pointer"
          }}>
              Generate
            </button>
            <button style={{
            backgroundColor: "#F5F5F5",
            color: "rgb(20, 21, 31)",
            border: "1px solid #E0E0E0",
            borderRadius: "20px",
            padding: "8px 18px",
            fontSize: "13px",
            fontWeight: 400,
            fontFamily: '"Evergrow Sans", Inter, sans-serif',
            cursor: "pointer"
          }}>
              Customize
            </button>
            <button style={{
            backgroundColor: "#000000",
            color: "#FFFFFF",
            border: "1px solid #000000",
            borderRadius: "20px",
            padding: "8px 18px",
            fontSize: "14px",
            fontWeight: 500,
            fontFamily: '"Evergrow Sans", Inter, sans-serif',
            cursor: "pointer"
          }}>
              Publish
            </button>
          </div>

          <div className="mb-[60px] md:mb-[100px]">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between" style={{
            marginBottom: "40px",
            gap: "16px"
          }}>
              <div>
                <h3 style={{
                color: "rgb(20, 21, 31)",
                fontFamily: '"Evergrow Sans", Inter, sans-serif',
                fontSize: "clamp(28px, 6vw, 40px)",
                fontWeight: 700,
                lineHeight: "1.3",
                border: "0px none rgb(20, 21, 31)",
                animation: "none 0s ease 0s 1 normal none running",
                margin: 0
              }} className="!font-medium">
                  Generate with AI.
                </h3>
                <p style={{
                color: "rgb(20, 21, 31)",
                fontFamily: '"Evergrow Sans", Inter, sans-serif',
                fontSize: "20px",
                fontWeight: 400,
                lineHeight: "30px",
                border: "0px none rgb(20, 21, 31)",
                animation: "none 0s ease 0s 1 normal none running",
                marginTop: "8px",
                marginBottom: 0,
                opacity: 0.8
              }}>
                  One prompt. A complete website.
                </p>
              </div>
              <div style={{
              flexShrink: 0
            }}></div>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
              <div className="w-full md:w-3/5" style={{
              backgroundColor: "#1A1A1A",
              borderRadius: "16px",
              overflow: "hidden"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/builder_generate_img.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/builder_generate_img.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/builder_generate_img.jpg-wvc-sizes" alt="Image showcasing the generation of a black and white photography portfolio website with AI Website Builder." className="w-full h-auto" style={{
                display: "block",
                borderRadius: "16px"
              }} loading="lazy" />
              </div>

              <div className="w-full md:w-2/5">
                <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "16px"
              }}>
                  {["Describe your business in a single sentence", "AI generates a full responsive site — pages, copy, layout", "Refine the look to match your brand", "Publish a real, production-ready site"].map((item, i) => <li key={i} data-index={i} style={{
                  color: "rgba(0, 0, 0, 0.8)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "20px",
                  fontWeight: 400,
                  lineHeight: "30px",
                  border: "0px none rgba(0, 0, 0, 0.8)",
                  textAlign: "left",
                  animation: "none 0s ease 0s 1 normal none running",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px"
                }} className="md:gap-3">
                      <span style={{
                    display: "inline-block",
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    marginTop: "12px",
                    flexShrink: "0"
                  }}></span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          <div className="mb-[60px] md:mb-[100px]">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between" style={{
            marginBottom: "40px",
            gap: "16px"
          }}>
              <div>
                <h3 style={{
                color: "rgb(20, 21, 31)",
                fontFamily: '"Evergrow Sans", Inter, sans-serif',
                fontSize: "clamp(28px, 6vw, 40px)",
                fontWeight: 700,
                lineHeight: "1.3",
                border: "0px none rgb(20, 21, 31)",
                animation: "none 0s ease 0s 1 normal none running",
                margin: 0
              }} className="!font-medium">
                  Customize with AI.
                </h3>
                <p style={{
                color: "rgb(20, 21, 31)",
                fontFamily: '"Evergrow Sans", Inter, sans-serif',
                fontSize: "20px",
                fontWeight: 400,
                lineHeight: "30px",
                border: "0px none rgb(20, 21, 31)",
                animation: "none 0s ease 0s 1 normal none running",
                marginTop: "8px",
                marginBottom: 0,
                opacity: 0.8
              }}>
                  Make it yours without learning a new tool.
                </p>
              </div>
              <div style={{
              flexShrink: 0
            }}></div>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
              <div className="w-full md:w-2/5 order-2 md:order-1">
                <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "16px"
              }}>
                  {["Edit anything by chatting with the AI", "Generate brand-quality images on demand", "Rewrite or sharpen your copy in seconds", "Add forms, maps, bookings, and more", "Clone any site by URL and make it yours"].map((item, i) => <li key={i} data-index={i} style={{
                  color: "rgba(0, 0, 0, 0.8)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "20px",
                  fontWeight: 400,
                  lineHeight: "30px",
                  border: "0px none rgba(0, 0, 0, 0.8)",
                  textAlign: "left",
                  animation: "none 0s ease 0s 1 normal none running",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px"
                }} className="md:gap-3">
                      <span style={{
                    display: "inline-block",
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    marginTop: "12px",
                    flexShrink: 0
                  }} />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="w-full md:w-3/5 order-1 md:order-2" style={{
              backgroundColor: "#1A1A1A",
              borderRadius: "16px",
              overflow: "hidden"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/builder_customize_img_new.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/builder_customize_img_new.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/builder_customize_img_new.jpg-wvc-sizes" alt="AI Co-Pilot interface assisting in website customization." className="w-full h-auto" style={{
                display: "block",
                borderRadius: "16px"
              }} loading="lazy" />
              </div>
            </div>
          </div>

          <div style={{
          paddingBottom: "40px"
        }}>
            <div style={{
            marginBottom: "40px"
          }}>
              <h3 style={{
              color: "rgb(20, 21, 31)",
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontSize: "clamp(28px, 6vw, 40px)",
              fontWeight: 700,
              lineHeight: "1.3",
              border: "0px none rgb(20, 21, 31)",
              animation: "none 0s ease 0s 1 normal none running",
              margin: 0
            }} className="!font-medium">
                Publish with ease.
              </h3>
              <p style={{
              color: "rgb(20, 21, 31)",
              fontFamily: '"Evergrow Sans", Inter, sans-serif',
              fontSize: "20px",
              fontWeight: 400,
              lineHeight: "30px",
              border: "0px none rgb(20, 21, 31)",
              animation: "none 0s ease 0s 1 normal none running",
              marginTop: "8px",
              marginBottom: 0,
              opacity: 0.8
            }}>
                Hit publish. We handle everything else.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              <div style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              overflow: "hidden",
              transition: "box-shadow 0.3s"
            }} onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)"} onMouseLeave={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)"}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/domain.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/domain.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/domain.jpg-wvc-sizes" alt="Selection of domain name options." className="w-full h-auto" style={{
                display: "block",
                borderRadius: "16px 16px 0 0"
              }} loading="lazy" />
                <div style={{
                padding: "24px 28px 28px"
              }}>
                  <h4 style={{
                  color: "rgb(20, 21, 31)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "22px",
                  fontWeight: 700,
                  lineHeight: "30px",
                  margin: "0 0 10px 0"
                }}>
                    Domain and hosting.
                  </h4>
                  <p style={{
                  color: "rgba(0, 0, 0, 0.8)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "18px",
                  fontWeight: 400,
                  lineHeight: "28px",
                  margin: 0
                }}>
                    Get a custom domain and reliable hosting in one click.
                    Already own a domain? Connect it in under five minutes.
                  </p>
                </div>
              </div>

              <div style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              overflow: "hidden",
              transition: "box-shadow 0.3s"
            }} onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)"} onMouseLeave={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)"}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/security.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/security.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/security.jpg-wvc-sizes" alt="Website security and performance features." className="w-full h-auto" style={{
                display: "block",
                borderRadius: "16px 16px 0 0"
              }} loading="lazy" />
                <div style={{
                padding: "24px 28px 28px"
              }}>
                  <h4 style={{
                  color: "rgb(20, 21, 31)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "22px",
                  fontWeight: 700,
                  lineHeight: "30px",
                  margin: "0 0 10px 0"
                }}>
                    Security and performance.
                  </h4>
                  <p style={{
                  color: "rgba(0, 0, 0, 0.8)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "18px",
                  fontWeight: 400,
                  lineHeight: "28px",
                  margin: 0
                }}>
                    90+ PageSpeed score, free SSL, automatic security updates.
                    Your site loads fast and stays safe — no plugins, no
                    patching, no IT bill.
                  </p>
                </div>
              </div>

              <div style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              overflow: "hidden",
              transition: "box-shadow 0.3s"
            }} onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)"} onMouseLeave={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)"}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/ai.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/ai.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/ai.jpg-wvc-sizes" alt="AI-powered text editing interface." className="w-full h-auto" style={{
                display: "block",
                borderRadius: "16px 16px 0 0"
              }} loading="lazy" />
                <div style={{
                padding: "24px 28px 28px"
              }}>
                  <h4 style={{
                  color: "rgb(20, 21, 31)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "22px",
                  fontWeight: 700,
                  lineHeight: "30px",
                  margin: "0 0 10px 0"
                }}>
                    AI text generation and editing.
                  </h4>
                  <p style={{
                  color: "rgba(0, 0, 0, 0.8)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "18px",
                  fontWeight: 400,
                  lineHeight: "28px",
                  margin: 0
                }}>
                    Write product descriptions, service pages, and blog posts in
                    seconds. SEO-tuned so Google can actually find you.
                  </p>
                </div>
              </div>

              <div style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              overflow: "hidden",
              transition: "box-shadow 0.3s"
            }} onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)"} onMouseLeave={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)"}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/analytics.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/analytics.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/analytics.jpg-wvc-sizes" alt="Website analytics graph displaying key metrics." className="w-full h-auto" style={{
                display: "block",
                borderRadius: "16px 16px 0 0"
              }} loading="lazy" />
                <div style={{
                padding: "24px 28px 28px"
              }}>
                  <h4 style={{
                  color: "rgb(20, 21, 31)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "22px",
                  fontWeight: 700,
                  lineHeight: "30px",
                  margin: "0 0 10px 0"
                }}>
                    Analytics and integrations.
                  </h4>
                  <p style={{
                  color: "rgba(0, 0, 0, 0.8)",
                  fontFamily: '"Evergrow Sans", Inter, sans-serif',
                  fontSize: "18px",
                  fontWeight: 400,
                  lineHeight: "28px",
                  margin: 0
                }}>
                    Plug in Google Analytics, Meta Pixel, Mailchimp, and the
                    rest of your stack. See what's working and double down.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}